import { appendReduxPart } from "infrastructure/store";

import { enterprisesSaga } from "./Enterprise.saga";
import { enterprises } from "./Enterprise.slice";

export * from "./Enterprise.actions";
export * from "./Enterprise.state";

appendReduxPart(
  {
    reducerName: enterprises.name,
    reducer: enterprises.reducer
  },
  enterprisesSaga()
);
